import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Avatar } from '@progress/kendo-react-layout';
import { Link } from 'react-router-dom';
import './TicketCard.scss';
import * as svg from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { ITicketListItem } from '../types/Ticket/Ticket';
import { IUserProfile } from '../types/User/User';
import ReactTimeago from 'react-timeago';
import { selectTenantUrl } from '../redux/selectors/authSelector';
import { useReduxSelector } from '../redux/hooks/hooks';

interface TicketCardProps {
    ticket: ITicketListItem;
    profile: IUserProfile | undefined;
}

const TicketCard: React.FC<TicketCardProps> = ({ ticket, profile }) => {
    const tenantUrl = useReduxSelector(selectTenantUrl);
    const [more, setMore] = React.useState(false);
    const colorClass = ticket.State === 'New' ? 'GreenBG' : ticket.State === 'On Hold' ? 'YellowBG' : ticket.State === 'Due' ? 'RedBG' : 'BlueBG';
    return (
        <div className='ticket-card'>
            <div className={colorClass}>
                <Card>
                    <CardHeader >
                        <Link className='nav-link ticket-link' to={`${tenantUrl}/calls/callhistory.aspx?call_Id=${ticket.Id}&from=teams`} target='_blank'>
                            <div className='header'>
                                {profile?.Features?.Profile_Action_Images && <ProfileImaage imageUrl={''} name={ticket.End_User_Name}></ProfileImaage>}
                                <div className='details'>
                                    <div className='row-1'>
                                        <h4 className='text-info'>{ticket.End_User_Name}</h4>
                                        <Button size='medium'>#{ticket.Id}</Button>
                                    </div>
                                    <div className='d-block'>{ticket.Company_Name} ({ticket.Project_Name})</div>
                                </div>
                                <div className={colorClass + ' shim'}>
                                </div>
                            </div>
                        </Link>

                    </CardHeader>
                    <CardBody>
                        <div className='lead truncate-3-lines' dangerouslySetInnerHTML={{ __html: ticket.Call_Desc }} ></div>
                    </CardBody>
                    <CardFooter><div className='row-nope text-muted footer'>

                        {/* <div className='col-6'><Button svgIcon={svg.chevronLeftIcon}></Button> </div> */}
                        {more ?
                            <div className="row" id={`collapseDetails_${ticket.Id}`}>
                                <div className="col-6">Created:</div><div className="col-6">{new Date(ticket.Open_Dt + 'Z').toLocaleDateString()} {new Date(ticket.Open_Dt + 'Z').toLocaleTimeString()}</div>
                                <div className="col-6">Status:</div><div className="col-6">{ticket.Status_Name}</div>
                                <div className="col-6">{profile?.Phrases.Priority}:</div><div className="col-6">{ticket.Priority_Name}</div>
                                {ticket.Type && <><div className="col-6">Type:</div><div className="col-6">{ticket.Type}</div></>}
                                {new Date(ticket.Due_Dt + 'Z').toString() !== 'Invalid Date' && <><div className="col-6">Due:</div><div className="col-6"><div>{new Date(ticket.Due_Dt + 'Z').toLocaleDateString()} {new Date(ticket.Due_Dt + 'Z').toLocaleTimeString()}</div></div></>}
                                <div className="col-6">Assigned To:</div><div className="col-6 font-bold">{ticket.Assigned_Staff.map(s => <div>{s.Name.replace('<phrase>Queue</phrase>', profile?.Phrases.Queue ?? 'Queue')}</div>)}</div>

                            </div>
                            : <div>Created: <ReactTimeago date={new Date(ticket.Open_Dt + 'Z')} title={new Date(ticket.Open_Dt + 'Z').toLocaleString()}></ReactTimeago> </div>}
                        <div> <Button svgIcon={more ? svg.chevronDownIcon : svg.chevronLeftIcon} fillMode='flat' onClick={() => setMore((m) => !m)}></Button></div>
                    </div></CardFooter>
                </Card>
            </div>
        </div >
    );
};

const ProfileImaage: React.FC<{ imageUrl: string, name?: string }> = ({ imageUrl, name }) => {
    const initials = name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : '';
    return (
        <span className="profile-image">
            {!imageUrl ?
                <Avatar type="image" size='medium' >
                    {initials && <div className='initials'>{initials}</div>}
                </Avatar>
                :
                <Avatar type="image" size='medium' className='image'>
                    <img src={imageUrl} alt="Profile" />
                </Avatar>}
        </span>
    );
}

export default TicketCard;
